import { Pronoun, PronounsCollection } from '@app/interfaces/pronouns.interface';

export function removeNullValuesFromPronounsCollection(pronounsCollection: PronounsCollection): PronounsCollection {
    return pronounsCollection?.filter((pronoun: Pronoun) => pronoun.value.length > 0);
}
